import React, { FC, LazyExoticComponent, ReactNode, lazy } from 'react';
import DashboardSkeleton from 'src/components/EOS/Dashboard/dashboard-skeleton/DashboardSkeleton';
import { eosPermissions } from 'src/components/EOS/constants/Permissions';

const EOSDashboard = lazy(() => import('../components/EOS/Dashboard'));
const ScenarioAnalysis = lazy(
  () => import('../components/EOS/components/ScenarioAnalysis')
);
const ForecastedData = lazy(
  () => import('../components/EOS/components/ForecastedData')
);
const EOSAudit = lazy(() => import('../components/EOS/components/Audit'));
const MappingConfig = lazy(
  () => import('../components/EOS/components/MappingConfig')
);
const EOSRolesAndManagement = lazy(
  () => import('../components/EOS/components/RolesAndManagement')
);
const EOSISG = lazy(() => import('../components/EOS/components/ISG'));

interface IEosRoute {
  path: string;
  component: LazyExoticComponent<FC>;
  fallback?: ReactNode;
  permission?: string;
}

const eosRoutes: IEosRoute[] = [
  {
    path: 'dashboard',
    component: EOSDashboard,
    fallback: <DashboardSkeleton />,
  },
  {
    path: 'scenario-analysis',
    component: ScenarioAnalysis,
    permission: eosPermissions.viewForecast,
  },
  {
    path: 'forecast',
    component: ForecastedData,
    permission: eosPermissions.viewForecast,
  },
  {
    path: 'audit',
    component: EOSAudit,
    permission: eosPermissions.viewAuditLog,
  },
  {
    path: 'mapping-config',
    component: MappingConfig,
    permission: eosPermissions.viewAndEditMappingConfiguration,
  },
  {
    path: 'roles-and-management',
    component: EOSRolesAndManagement,
    permission: eosPermissions.viewAuditLog,
  },
  {
    path: 'isg',
    component: EOSISG,
  },
];

export default eosRoutes;
